import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=52da3bd3&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=52da3bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da3bd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52da3bd3')) {
      api.createRecord('52da3bd3', component.options)
    } else {
      api.reload('52da3bd3', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=52da3bd3&scoped=true&", function () {
      api.rerender('52da3bd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4R375Y0VliM7T/JS/comp/CookieBox.vue"
export default component.exports